var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43999 6.85822L10.56 4.2868M5.43999 9.14394L10.56 11.7154M3.14284 10.5725C4.563 10.5725 5.71427 9.42124 5.71427 8.00108C5.71427 6.58092 4.563 5.42965 3.14284 5.42965C1.72268 5.42965 0.571411 6.58092 0.571411 8.00108C0.571411 9.42124 1.72268 10.5725 3.14284 10.5725ZM12.8571 15.4297C14.2772 15.4297 15.4286 14.2783 15.4286 12.8582C15.4286 11.4381 14.2772 10.2868 12.8571 10.2868C11.437 10.2868 10.2857 11.4381 10.2857 12.8582C10.2857 14.2783 11.437 15.4297 12.8571 15.4297ZM12.8571 5.71537C14.2772 5.71537 15.4286 4.5641 15.4286 3.14394C15.4286 1.72378 14.2772 0.57251 12.8571 0.57251C11.437 0.57251 10.2857 1.72378 10.2857 3.14394C10.2857 4.5641 11.437 5.71537 12.8571 5.71537Z",
    stroke: "#AA1A5F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteButton);
export default __webpack_public_path__ + "static/media/inviteButton.22098cc9d75dc5419baf8e088c6dc4bb.svg";
export { ForwardRef as ReactComponent };